import {
    ActionItemModifier,
    ActionItemStyle,
    ButtonActionItem
} from '../../../../elements/components/action-item/entities/action-item.entity';
import { IconSize } from '../../../../elements/components/icon/entities/icon-sizes.entity';

export enum FormTagListActionItemLocation {
    Default = 'Default',
    Joined = 'Joined',
    None = 'None'
}

export class FormTagListActionItem implements ButtonActionItem {
    label = '';
    icon: string;
    iconSize: IconSize = IconSize.REGULAR;
    style: ActionItemStyle.PureSquareIconButtonInverted | ActionItemStyle.PureIconButton;
    location: FormTagListActionItemLocation;
    modifiers: ActionItemModifier[] = [ActionItemModifier.ActionInInputField];
    eventListener = (event: MouseEvent) => {};

    constructor(location: FormTagListActionItemLocation = FormTagListActionItemLocation.Default, icon: string = 'add') {
        this.location = location;
        this.icon = icon;
        this.style =
            location === FormTagListActionItemLocation.Default
                ? ActionItemStyle.PureIconButton
                : ActionItemStyle.PureSquareIconButtonInverted;
    }
}
